import * as actionTypes from "./actionTypes";
import { DEFAULT_PAGE_SIZE } from "./constants";

const initialState = {
  loading: false,
  rows: [],
  columns: [],
  totalCount: 0,
  searchText: "",
  statuses: [],
  pagination: { pageSize: DEFAULT_PAGE_SIZE, currentPage: 1 },
  detailsByInvoiceId: {}
};

const normalizeList = (data) => {
  if (!data) return { rows: [], columns: [], totalCount: 0 };
  if (Array.isArray(data)) return { rows: data, columns: [], totalCount: data.length };

  const rows =
    (Array.isArray(data.dataSource) && data.dataSource) ||
    (Array.isArray(data.rows) && data.rows) ||
    (Array.isArray(data.items) && data.items) ||
    [];

  const columns = Array.isArray(data.columns) ? data.columns : [];

  const totalCount = data.totalCars ?? data.totalCount ?? data.total ?? rows.length;

  return { rows, columns, totalCount };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_B2B_INVOICES_START:
      return { ...state, loading: true };

    case actionTypes.FETCH_B2B_INVOICES_SUCCESS: {
      const { rows, columns, totalCount } = normalizeList(action.data);
      return { ...state, loading: false, rows, columns, totalCount };
    }

    case actionTypes.FETCH_B2B_INVOICES_FAIL:
      return { ...state, loading: false };

    case actionTypes.FETCH_B2B_INVOICE_DETAIL_START:
      return {
        ...state,
        detailsByInvoiceId: {
          ...state.detailsByInvoiceId,
          [action.invoiceId]: {
            ...(state.detailsByInvoiceId[action.invoiceId] || {}),
            loading: true
          }
        }
      };

    case actionTypes.FETCH_B2B_INVOICE_DETAIL_SUCCESS:
      return {
        ...state,
        detailsByInvoiceId: {
          ...state.detailsByInvoiceId,
          [action.invoiceId]: {
            loading: false,
            invoice: action.data?.invoice || null,
            items: action.data?.items || []
          }
        }
      };

    case actionTypes.FETCH_B2B_INVOICE_DETAIL_FAIL:
      return {
        ...state,
        detailsByInvoiceId: {
          ...state.detailsByInvoiceId,
          [action.invoiceId]: {
            ...(state.detailsByInvoiceId[action.invoiceId] || {}),
            loading: false
          }
        }
      };

    case actionTypes.SET_B2B_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.text,
        pagination: { ...state.pagination, currentPage: 1 }
      };

    case actionTypes.SET_B2B_STATUSES:
      return {
        ...state,
        statuses: action.statuses || [],
        pagination: { ...state.pagination, currentPage: 1 }
      };

    case actionTypes.SET_B2B_CURRENT_PAGE:
      return {
        ...state,
        pagination: { ...state.pagination, currentPage: action.page }
      };

    case actionTypes.SET_B2B_PAGE_SIZE:
      return {
        ...state,
        pagination: { pageSize: action.size, currentPage: 1 }
      };

    case actionTypes.RESET_B2B_PORTAL:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
